import Router from "./util/Router";

// Routes
import common from "./routes/common";
import home from "./routes/home";
import blog from "./routes/blog";
import archive from "./routes/archive";
//import pageTemplateBrochureRequest from "./routes/page-template-brochure-request";

const routes = new Router({
  common,
  home,
  blog,
  archive
  // taxProductCat,
  // singleProduct,
  // pageTemplateBrochureRequest,
});

function ready(func) {
  if (
    document.attachEvent
      ? document.readyState === "complete"
      : document.readyState !== "loading"
  ) {
    func();
  } else {
    document.addEventListener("DOMContentLoaded", func);
  }
}

function loadEvents() {
  routes.loadEvents();
}

ready(loadEvents);
